import { loginKeyreq, allreq, resourceReq } from './axiosFun';
// 登录接口
export const login = (params) => { return allreq("post", "/api/Login", params) };

// 退出登录接口
export const logOut = () => { return allreq("get", "/api/Logout") };
//isLogin
export const isLogin = (identifier_type, identifier_value) => { return allreq("get", `/api/isLogin?identifier_type=${identifier_type}&identifier_value=${identifier_value}`) };

// 验证httphost接口
export const httphostCheck = (httphost) => { return loginKeyreq("get", `/api/webSchool/getSchoolList/?httphost=${httphost}`) };

//路由校验接口
export const routerCheck = (identifier_type, plain_timestamp, encrypted_timestamp, wechat_id) => { return loginKeyreq("get", `/api/device_verification?identifier_type=${identifier_type}&plain_timestamp=${plain_timestamp}&encrypted_timestamp=${encrypted_timestamp}&wechat_id=${wechat_id}`) };

// 注册接口
export const register = (params) => { return loginKeyreq("post", "/api/Register", params) };

// 注册获取验证码接口
export const sendCode = (Phone) => { return loginKeyreq("post", "/api/Sendcode", Phone) };

// 修改密码接口
export const changePassword = (params) => { return loginKeyreq("post", "/api/ChangePassword", params) };

// 忘记密码--验证手机号和验证码接口
export const codeVerifition = (Phone) => { return loginKeyreq("post", "/api/CodeVerifition", Phone) };

//首页基本信息内容获取
export const getHomeInfo = (params) => { return loginKeyreq("get", "/api/webCustomization/getwebCustomizationList/", params) };

//首页热门课程
export const getHotCourse = () => { return loginKeyreq("get", "/api/webCustomization/getwebPopullarList/") };

//获取线下主机模拟选项
export const category = () => { return loginKeyreq("get", "/api/Category/") };

//获取线下主机模拟内容
export const filterExamination = (id) => { return loginKeyreq("get", `/api/Examination/filterExamination_Type/?filtertype=${id}`); };

//获取线下主机模拟类型
export const filterExaminationType = (id) => { return loginKeyreq("get", `/api/webModule/getwebcategory_List/?typeid=${id}`); };

//获取线下主机模拟考题
export const filterResource = (id) => { return loginKeyreq("get", `/api/Resource/filterResource_Type/?filtertype=${id}`); };

//线下主机模拟资源跳转
export const resourceAd = (type, resourcecode, tokenUrl, exam_session, exam_duration, codeRate) => { return loginKeyreq("get", `/api/Resource/VisitResource/?resourcecode=${resourcecode}&type=${type}&tokenUrl=${tokenUrl}&exam_session=${exam_session}&exam_duration=${exam_duration}&codeRate=${codeRate}`) }

//获取线下主机模拟考区
export const examArea = (filtertype, filtermodel) => { return loginKeyreq("get", `/api/Examination/filterExamination_list/?filtertype=${filtertype}&filtermodel=${filtermodel}`) };

//进入线下主机模拟考试页生成考试标识uuid
export const exam_session = (params) => { return loginKeyreq("post", '/api/webMyResource/MockExams/', params) }

//获取线下主机模拟选择是否上次考试或者开始新考试
export const exam_sessionInfo = (params) => { return loginKeyreq("post", `/api/webMyResource/MockExamSelect/`, params) };

//获取线下主机模拟提交
export const submit = (params) => { return loginKeyreq("post", "/api/webMyResource/SubmitExam/", params) };

//获取线下主机模拟历史
export const history = (page, maxSize, DeviceModel, type) => { return loginKeyreq("get", `/api/webMyResource/getMyResourceList/?page=${page}&maxSize=${maxSize}&DeviceModel=${DeviceModel}&type=${type}`); };

//个人中心 信息修改
export const uptUserInfo = (params) => { return loginKeyreq("post", "/api/User/EditUserNameAndFirstName/", params) };
//个人中心 密码修改
export const uptUserPassword = (params) => { return loginKeyreq("post", "/api/UserChangePassword", params) };

// 获取理论题库
export const theoryInfo = () => { return loginKeyreq("get", "/api/webFirstFloor/getshowFirstFloorList/") };

//获取理论题库-详情页
export const theoryInfoDetail = (id) => { return loginKeyreq("get", `/api/webModule/getwebModuleList/?filterfirst=${id}`, ); };

//获取理论题库考题
export const theoryResource = (id, firstfloorId) => { return loginKeyreq("get", `/api/webQuestionType/getwebQuestionTypeList/?filtersecond=${id}&firstfloor_id=${firstfloorId}`); };


//获取模拟考试、智能学习、押题模考 答题页
export const theoryResourceDetail = (id, type, lastid) => { return loginKeyreq("get", `/api/webThirdFloorList/getThirdFloorList/?firstfloor=${id}&type=${type}&lastid=${lastid}`); };

//模拟考试、押题模考 提交
export const theoryResourceSubmit = (params) => { return loginKeyreq("post", "/api/ExamRecords/", params) };

//历史成绩获取
export const theoryResourceHistory = (id, page, maxSize) => { return loginKeyreq("get", `/api/webExamRecords/getExamRecordsList/?firstfloor=${id}&page=${page}&maxSize=${maxSize}`) };

//历史成绩详情获取
export const theoryResourceHistoryDetail = (id) => { return loginKeyreq("get", `/api/webUserBatch/getUserBatchList/?userbatch=${id}`) };

//我的错题
export const myError = (id) => { return loginKeyreq("get", `/api/webExamRecords/getStrengthenList/?firstfloor=${id}`) };

//错题重做
export const myErrorRedo = (id) => { return loginKeyreq("get", `/api/webExamRecords/getStrengthenThirdList/?ExamRecordsId=${id}`) };

//做对后删除对应错题
export const myErrorDelete = (params) => { return loginKeyreq("post", `/api/webExamRecords/DeleteStrengthen/`, params) };

//获取理论视频
export const visionVideo = () => { return loginKeyreq("get", "/api/webTheoryVideoType/getTheoryVideoList/") };

//获取理论视频-视频页
export const visionVideoInfo = (id) => { return loginKeyreq("get", `/api/webTheoryVideoChapter/getTheoryVideoList/?typeid=${id}`) };

//视频进度上传
export const videoProgress = (params) => { return loginKeyreq("post", "/api/webMyVideo/create_update_Video/", params) };

//获取实操视频
export const visualVideo = () => { return loginKeyreq("get", "/api/webPracticalVideoType/getPracticalVideoList/") };

//获取实操视频区分类型
export const visualVideoType = (visualId) => { return loginKeyreq("get", `/api/webPracticalVideoType/getPracticalVideoList/?type=${visualId}`) };

//获取实操视频-实操视频类型
export const visualVideoTypeInfo = (id) => { return loginKeyreq("get", `/api/webPracticalVideoChapter/getPracticalVideoChapterList/?typeid=${id}`) };

//获取实操视频-视频页
export const visualVideoInfo = (id, typeid) => { return loginKeyreq("get", `/api/webVideo/getPracticalVideoList/?typeid=${id}&chapterid=${typeid}`) };

//收藏或取消收藏
export const collect = (params) => { return loginKeyreq("post", "/api/MyCollection/create_update_Collection/", params) };
//获取收藏
export const getCollect = (firstfloor) => { return loginKeyreq("get", `/api/webMyCollection/getMyCollectionList/?firstfloor=${firstfloor}`) };

//获取资源购买
export const resourceBuy = () => { return loginKeyreq("get", `/api/Category/`) };
//选择机型
export const resourceBuyInfo = () => { return loginKeyreq("get", `/api/webnewDeviceModel/getnewDeviceModelList/`) };
//选择开通时长
export const resourceBuyTime = () => { return loginKeyreq("get", `/api/webResourcePackagePricePlan/getResourcePackagePricePlanList/`) };

//选择资源
export const resourceBuyResource = () => { return loginKeyreq("get", `/api/webSelectResource/getSelectResourceList/`) };
//获取开通时长id及对应价格
export const resourceBuyTimeInfo = (categoryId, packAge, is_allresource) => { return loginKeyreq("get", `/api/webResourcePackagePricePlan/getwebResourcePackagePricePlanList/?CategoryId=${categoryId}&package=${packAge}&is_allresource=${is_allresource}`) };
//创建订单并生成微信支付二维码
export const resourceBuyCreate = (params) => { return loginKeyreq("post", `/api/Order/`, params) };
//取消支付订单
export const resourceBuyCancel = () => { return loginKeyreq("get", `/api/Order/editOrder/`) };
//获取订单支付状态
export const resourceBuyOrder = (order_number) => { return loginKeyreq("get", `/api/Order/getOrderstatus/?order_number=${order_number}`) };

//个人中心-我的资源
export const myResource = () => { return loginKeyreq("get", `/api/User/getUserPackage/`) };

//手机端-基本信息获取
export const phoneCustomization = () => { return loginKeyreq("get", `/api/webphoneCustomization/getwebCustomizationList_phone/`) };

//手机端-微信用户信息获取
export const getWechatUser = (access_token, openid) => {
    return allreq("get", `https://api.weixin.qq.com/sns/userinfo?access_token=${access_token}&openid=${openid}&lang=zh_CN`)
};
//使用access_token获取用户信息
export const getUserInfo = (access_token, openid) => { return allreq("get", `/api/wxlogin_code?code=${access_token}&state=${openid}`) };

//微信账号绑定网页端账号并登录
export const bindUser = (data) => { return allreq("post", `/api/wxLogin_bind`, data) };

//微信accesstoken检验是否有效
export const checkAccessToken = (access_token, openid) => { return allreq("get", `/api/check_access_token?access_token=${access_token}&openid=${openid}`) };

//调用wx 支付接口
export const wxPay = (data) => { return loginKeyreq("post", `/api/create_pay_order`, data) };

//取消wx 支付
export const wxPayCancel = (out_trade_no) => { return loginKeyreq("get", `/api/cancel_order?out_trade_no=${out_trade_no}`) };

//鉴定站省份获取
export const province = () => { return loginKeyreq("get", `/api/webProvince/getProvinceList/`) };

//鉴定站城市获取
export const city = (provinceId) => { return loginKeyreq("get", `/api/webCity/getCityList/?province=${provinceId}`) };
//鉴定站日志获取
export const logAppraisal = (cityid) => { return loginKeyreq("get", `/api/webCity/record_city_certification_entry/?cityid=${cityid}`) };

//系统架构获取
export const systemStructure = () => { return loginKeyreq("get", `/api/webSystemArchitecture/getSystemArchitectureList/`) };
//系统架构日志获取
export const logSystemStructure = (systemid) => { return loginKeyreq("get", `/api/webArchitectureResource/record_Resource_certification_entry/?ArchitectureResource_id=${systemid}`) };

//口述提交[考试模式]
export const submitMode = (params) => { return resourceReq("post", `/api/speech/proxy/`, params) };